import router from './router/index'
import httpServer from './http/http-server'
import store from './store/index'
import {Message} from 'element-ui'

const whiteList = ['/login','/registry','/faceResult.html', '/chain', '/NotariaIndex',
  '/TransactGuide','/GuidDetail','/BidNotice','/AboutUs','/Verification', '/findPwd',
  '/notarial-certificate-extract', '/safe-keep-letter-extract','/Appointment','/NotarAppointment','/NotariaIndex2'];// 不重定向白名单

function makeRouters (perms, next, to) {

}

function getUser (to, from, next) {

}

router.beforeEach((to, from, next) => {
  console.log(to.path)
  if (whiteList.indexOf(to.path) > -1) return next()

  httpServer.profile().then(res => {
    if (!res.success) {
      router.push('/login')
      return
    }
    store.commit('SET_PROFILE', res.data);
    //entityStatus   实名状态 0:未通过/未申请，1:已通过
    if (res.data.entityStatus !== 1) {
      router.push({path: 'registry',query:{entityStatus:+res.data.entityStatus===1?1:-1}})
    }
    next()
  })

})

router.afterEach(() => {}) // 结束Progress;



// WEBPACK FOOTER //
// ./src/permission.js